var map = {
	"./bootstrap.svg": 6496,
	"./express.svg": 3227,
	"./flutter.svg": 3111,
	"./html.svg": 4294,
	"./mongo.svg": 4624,
	"./node.svg": 3942,
	"./react.svg": 7188,
	"./rn.svg": 9223,
	"./socket.svg": 9281,
	"./tailwind.svg": 8248,
	"./ts.svg": 2883,
	"./vue.svg": 1896,
	"./vuetify.svg": 4362
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9471;